export const TYPES = {
  OnboardingUseCases: Symbol.for('OnboardingUseCases'),
  OnboardingRepository: Symbol.for('OnboardingRepository'),
};
